import { ThemeProvider } from '@emotion/react';
import {
  faCircleChevronLeft,
  faTimes,
  faWarning,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import variables from '../../../scss/_variables.scss';
import { useEffect, useState } from 'react';
import { getToast } from '../../../utils/toastConfig';
import { GlobalVariables } from '../../../globalVar';
import customAxios from '../../../utils/customAxios';

const theme = createTheme({
  palette: {
    primary: {
      main: variables.redDabi,
    },
  },
});

export const DeleteRoleModal = ({
  roleInfo,
  showModal,
  setShowModal,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const [roleName, setRoleName] = useState('');
  const [description, setDescription] = useState('');

  // Translation hooks
  const {
    modalYesString,
    modalNoString,
    roleNameString,
    createdAtString,
    updatedByString,
    updatedAtString,
  } = useTranslationHook();

  //* Data fill
  useEffect(() => {
    if (roleInfo) {
      // Populate bank details
      setRoleName(roleInfo.role_name || '');
      setDescription(roleInfo.description || '');
    }
  }, [roleInfo]);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const endpoint = `${GlobalVariables.getURL()}roles/delete/${roleInfo.id}`;

      const response = await customAxios.delete(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 200) {
        getToast({
          status: 'success',
          title: 'Rol eliminado correctamente',
        });
        setShowModal(false);
        refreshData();
      }
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({ status: 'error', title: error.response.data.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        fullWidth={true}
        maxWidth='md'
      >
        <DialogTitle>
          <Typography className='inventory-movmodal-title'>
            Eliminar Rol
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={() => setShowModal(false)}
          sx={{
            position: 'absolute',
            right: 20,
            top: 20,
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant='h5'>
                ¿Seguro que deseas eliminar este rol?
              </Typography>
            </Grid>
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='h6'>
                  <span style={{ fontWeight: 'bold' }}>ID:</span> {roleInfo.id}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='h6'>
                  <span style={{ fontWeight: 'bold' }}>
                    {'Nombre del rol'}: {/* TODO: Translate */}
                  </span>{' '}
                  {roleName}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <button
            className='modal-button'
            onClick={() => handleDelete()}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faWarning} /> {modalYesString}
          </button>
          <button
            className='modal-button no'
            onClick={() => setShowModal(false)}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faCircleChevronLeft} /> {modalNoString}
          </button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};
